<template>
  <div id="app" :class="{ 'pc-app': isDesktop }">
    <div v-if="!i18nLoaded" class="loading-container">
      <van-loading type="spinner" color="#1989fa" vertical></van-loading>
    </div>
    <template v-else>
      <!-- PC 页面的 Header 和 Footer -->
      <template v-if="isDesktop">
        <PcHeader v-if="!$route.meta.hideHeader" />
        <!-- key 用 path 而非 fullPath：翻页/搜索等 query 变化不重建组件，避免请求重复发送 -->
        <main class="pc-content-wrapper" :key="$route.path">
          <router-view />
        </main>
        <PcFooter v-if="!$route.meta.hideFooter" />
		<FloatingContact />
      </template>
      <!-- H5 页面 -->
	 <template v-else>
	   <router-view :key="$route.fullPath" />
	   <!-- <MobileContact /> -->
	 </template>
    </template>
  </div>
</template>

<script>
import { loadFulltext } from './utils/i18n'
import { updateSeo } from './utils/seo'
import { Loading } from 'vant'
import PcHeader from '@/components/pc/Header.vue'
import PcFooter from '@/components/pc/Footer.vue'
import FloatingContact from './components/pc/FloatingContact.vue'
import MobileContact from './components/h5/MobileContact.vue'

// 设备检测工具函数
function isDesktop() {
  const width = window.innerWidth || document.documentElement.clientWidth
  const ua = navigator.userAgent.toLowerCase()
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua)
  return width >= 1024 && !isMobileUA
}

export default {
  name: 'App',
  components: {
    [Loading.name]: Loading,
    PcHeader,
    PcFooter,
    FloatingContact,
	MobileContact
  },
  data() {
    return {
      i18nLoaded: false,
      isDesktop: isDesktop()
    }
  },
  created() {
    // 初始化加载语言文本
    loadFulltext().then(() => {
      // fulltext 就绪后，按当前路由重新应用页面级 SEO 配置。
      // 原逻辑在此无条件写 fulltext 通用 title，导致首访/预渲染页面永远只显示
      // 通用 title，后台「多语言 SEO」表中 home/blog/about/faq 的独立配置不生效。
      // 此处改为走 updateSeo：有页面级配置则用页面级，无则回落通用值。
      updateSeo(this.$route)
      // 语言加载完成后显示应用
      this.i18nLoaded = true
    }).catch(() => {
      // 即使加载失败也显示应用，避免一直loading
      this.i18nLoaded = true
    })
  }
}
</script>

<style>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}

#app.pc-app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.pc-content-wrapper {
  flex: 1;
  width: 100%;
}

.fp-watermark {
  display: none !important;
}
</style>
